import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "route-sheet-details" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm bg-white border px-4 py-6 text-gray-400 select-none"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении детальной информации о маршрутном листе произошла ошибка ", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_10 = { class: "mt-9 bg-white rounded" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 flex items-center justify-between border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "ДОСТАВКИ")
], -1)
const _hoisted_12 = { class: "mt-3 p-5" }
const _hoisted_13 = {
  class: "max-w-full overflow-hidden overflow-x-auto",
  style: {"padding-bottom":"70px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_route_sheet_invoice_row = _resolveComponent("route-sheet-invoice-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.routeSheetDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_3,
                  _createVNode(_component_new_button, {
                    class: "mt-3",
                    onClick: _ctx.loadRouteSheet
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.routeSheetDetails)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" Нет данных ")
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_page_title, { title: _ctx.pageTitle }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_button_dropdown, {
                title: "Выберите действие",
                class: "whitespace-nowrap",
                placement: "bottom",
                "allowed-placements": ['bottom']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_new_button, {
                    loading: _ctx.report_state.is_loading,
                    disabled: _ctx.report_state.is_loading,
                    class: "NewButton--search",
                    onClick: _ctx.downloadReport
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" Выгрузить отчет ")
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]),
                  (_ctx.isResend)
                    ? (_openBlock(), _createBlock(_component_new_button, {
                        key: 0,
                        loading: _ctx.one_c_state.is_loading,
                        disabled: _ctx.one_c_state.is_loading,
                        class: "NewButton--search",
                        onClick: _ctx.resendOneC
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createTextVNode(" Переотправить в 1C ")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_new_button, {
                class: "NewButton--reset",
                onClick: _ctx.onBack
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode(" Назад ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_new_table, {
                  columns: _ctx.TABLE_COLUMNS,
                  rows: _ctx.state.routeSheetDetails.invoices,
                  style: {"width":"2500px"}
                }, {
                  td: _withCtx(({ column, row, index }) => [
                    _createVNode(_component_route_sheet_invoice_row, {
                      column: column,
                      row: row,
                      index: index
                    }, null, 8, ["column", "row", "index"])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ])
          ])
        ]))
  ]))
}